var pipe = require('./pipe')
var checkRequired = require('./check-required')
var forwardError = require('./forward-error')
var isObject = require('./is-object')
var ERRORS = require('../constants/error-types')
var SYMBOLS = require('../constants/currency').SYMBOLS_BY_CODE

var USA = {
  decimal: '.',
  symbolPlacement: 'prefix',
  symbol: SYMBOLS.USD,
  thousands: ',',
  spacedPercent: false,
  percentSymbol: '%',
}

var EU = {
  decimal: ',',
  symbolPlacement: 'suffix',
  symbol: SYMBOLS.EUR,
  thousands: '.',
  spacedPercent: true,
  percentSymbol: '%',
}
var CLP = {
  decimal: ',',
  symbolPlacement: 'prefix',
  symbol: SYMBOLS.CLP,
  thousands: '.',
  spacedPercent: true,
  percentSymbol: '%',
}

var BRL = {
  decimal: ',',
  symbolPlacement: 'prefix',
  symbol: SYMBOLS.BRL,
  thousands: '.',
  spacedPercent: false,
  percentSymbol: '%',
}

var formats = {
  'en-CA': USA,
  'en-GB': Object.assign({}, USA, { symbol: SYMBOLS.GBP }),
  'en-IE': Object.assign({}, USA, { symbol: SYMBOLS.EUR }),
  'en-US': USA,
  'es-MX': USA,
  'es-ES': EU,
  'fr-FR': Object.assign({}, EU, { thousands: ' ' }),
  'hi-IN': Object.assign({}, USA, { symbol: SYMBOLS.INR }),
  'zh-CN': Object.assign({}, USA, { symbol: SYMBOLS.CNY }),
  'es-US': USA,
  'es-CL': Object.assign({}, CLP, {
    symbol: SYMBOLS.CLP,
  }),
  'pt-BR': Object.assign({}, BRL, { symbol: SYMBOLS.BRL }),
  'fr-CA': Object.assign({}, USA, { symbol: SYMBOLS.CAD }),
}

function getRawNumberValue(config) {
  return function rawNumber(value, options) {
    if (typeof value !== 'string') return NaN
    var opts = options || {}
    var regx = new RegExp(
      '([' + config.decimal + config.thousands + config.symbol + '%])',
      'g'
    )
    var num = +value.replace(regx, function(m, p1) {
      return p1 === config.decimal ? '.' : ''
    })
    var decimalLimit = opts.decimalLimit ? +opts.decimalLimit : 2
    return !isNaN(num) ? num.toFixed(decimalLimit) : num
  }
}

function validate(format) {
  return function validateNumber(data) {
    var rawNumber = getRawNumberValue(
      Object.assign({ decimalLimit: data.decimalLimit }, format)
    )(data.value)
    if (isNaN(rawNumber)) return ERRORS.invalid

    var min = +data.minValue
    var max = +data.maxValue
    if (!isNaN(min) && rawNumber < min) return ERRORS.minNumber
    if (!isNaN(max) && rawNumber > max) return ERRORS.maxNumber
    return ''
  }
}

// named exports (mostly for testing)
exports.formats = formats
exports.getRawNumberValue = getRawNumberValue
exports.validate = validate
// util export
exports.getByLocale = function getNumberUtils(config) {
  var locale
  // manual locale passing (useful for i18n inputs)
  if (typeof config === 'string') {
    locale = config
  } else if (isObject(config)) {
    locale = config.locale
  }
  var format = formats[locale] || USA

  format = config.currency
    ? Object.assign({}, format, { symbol: SYMBOLS[config.currency] })
    : format

  return {
    format: format,
    getRawValue: getRawNumberValue(format),
    validate: pipe(checkRequired, forwardError(validate(format))),
  }
}
